<template>
  <el-dialog
    title="查看回复"
    :visible.sync="dialogVisible"
    width="700px"
    @close="handleClose"
  >
    <el-table
      :data="replyList"
      border
      style="width: 100%"
      v-loading="loading"
      element-loading-text="加载中..."
    >
      <el-table-column prop="appraiseUserName" label="回复人" align="center" width="120" />
      <el-table-column prop="context" label="回复内容" align="center" />
      <el-table-column prop="createTime" label="回复时间" align="center" width="180" />
    </el-table>
    <div v-if="replyList.length === 0 && !loading" style="text-align: center; padding: 20px; color: #909399;">
      暂无回复
    </div>
  </el-dialog>
</template>

<script>
import { queryShopAppraise } from '@/api/goods/productDetailApi'

export default {
  name: 'ViewAppraiseReplies',
  props: {
    shopId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      replyList: [],
      appraise: {}
    }
  },
  methods: {
    open(appraise) {
      this.appraise = appraise || {}
      this.replyList = []
      this.dialogVisible = true
      this._loadReplies()
    },
    close() {
      this.dialogVisible = false
    },
    handleClose() {
      this.replyList = []
      this.appraise = {}
    },
    async _loadReplies() {
      if (!this.appraise.appraiseId) {
        return
      }
      this.loading = true
      try {
        const params = {
          parentAppraiseId: this.appraise.appraiseId,
          shopId: this.shopId,
          page: 1,
          row: 100
        }
        const res = await queryShopAppraise(params)
        this.replyList = res.data || []
      } catch (error) {
        console.error('加载回复列表失败:', error)
        this.$message.error('加载回复列表失败')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
</style>

